import React, { useState } from 'react';
import { EntityMetadataResponse } from '../../../api/OasisBackendApi';
import MultiSelectField from './MultiSelectField';
import KeyMappingField from './KeyMappingField';

interface MetadataModalProps {
  metadata: EntityMetadataResponse;
  onClose: () => void;
  onSave: (metadata: EntityMetadataResponse) => void;
  saveButtonText: string;
  isLoading?: boolean;
}

const MetadataModal: React.FC<MetadataModalProps> = ({
  metadata,
  onClose,
  onSave,
  saveButtonText,
  isLoading = false
}) => {
  const [editedMetadata, setEditedMetadata] = useState<EntityMetadataResponse>(metadata);
  const handleSave = () => {
    onSave(editedMetadata);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="bg-gray-900 text-white" style={{
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'auto',
        width: '90%'
      }}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Edit Entity Metadata</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            ✕
          </button>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Entity Description
            </label>
            <textarea
              value={editedMetadata.entity_description}
              onChange={(e) => setEditedMetadata({
                ...editedMetadata,
                entity_description: e.target.value
              })}
              className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows={4}
              placeholder="Enter entity description..."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Entity Type
            </label>
            <input
              value={editedMetadata.entity_type}
              onChange={(e) => setEditedMetadata({
                ...editedMetadata,
                entity_type: e.target.value
              })}
              className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter entity type..."
            />
          </div>
          <MultiSelectField
            label="Semantic Index Keys"
            selectedKeys={editedMetadata.semantic_index_keys}
            allKeys={editedMetadata.all_keys}
            onSelectionChange={(keys) => setEditedMetadata({
              ...editedMetadata,
              semantic_index_keys: keys
            })}
          />

          <MultiSelectField
            label="Oasis Index Keys"
            selectedKeys={editedMetadata.oasis_index_keys}
            allKeys={editedMetadata.all_keys}
            onSelectionChange={(keys) => setEditedMetadata({
              ...editedMetadata,
              oasis_index_keys: keys
            })}
          />

          <MultiSelectField
            label="Oasis Form Data Index Keys"
            selectedKeys={editedMetadata.oasis_form_data_index_keys}
            allKeys={editedMetadata.all_keys}
            onSelectionChange={(keys) => setEditedMetadata({
              ...editedMetadata,
              oasis_form_data_index_keys: keys
            })}
          />

          <MultiSelectField
            label="Simple Keys"
            selectedKeys={editedMetadata.simple_keys}
            allKeys={editedMetadata.all_keys}
            onSelectionChange={(keys) => setEditedMetadata({
              ...editedMetadata,
              simple_keys: keys
            })}
          />

          <KeyMappingField
            label="UI Key Mappings"
            mappings={editedMetadata.ui_mapping}
            allKeys={editedMetadata.all_keys}
            onMappingChange={(mappings) => setEditedMetadata({
              ...editedMetadata,
              ui_mapping: mappings
            })}
          />
        </div>

        <div className="flex justify-end space-x-2 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isLoading}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Uploading...' : saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MetadataModal; 